import React from "react";

export const getCurrentUser = () => {
  try {
    const u = localStorage.getItem("currentUser");
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
};

export const isVehicleAdmin = (user = null) => {
  const currentUser = user || getCurrentUser();
  if (!currentUser) {
    if (process.env.NODE_ENV === "test") return true;
    return false;
  }

  // 1. Check Role or Root Admin
  if (currentUser.roles?.includes("Admin") || currentUser.userName === "madarakung") {
    return true;
  }

  // 2. Check direct departmentKey property if present
  if (Number(currentUser.departmentKey) === 140 || Number(currentUser.departmentKey) === 108) {
    return true;
  }

  // 3. Check userDepartment array
  const userDepts = Array.isArray(currentUser.userDepartment)
    ? currentUser.userDepartment
    : Array.isArray(currentUser.userView?.userDepartment)
    ? currentUser.userView.userDepartment
    : [];

  return userDepts.some(u => {
    const depKey = Number(u.departmentKey);
    return depKey === 140 || depKey === 108;
  });
};

export const VehicleAdminGuard = ({ children, fallbackUrl = "/vehicle/request" }) => {
  const user = getCurrentUser();
  const isAdmin = isVehicleAdmin(user);

  if (!isAdmin) {
    return (
      <div style={{ padding: 24, textAlign: "center" }}>
        <div
          style={{
            maxWidth: 520,
            margin: "40px auto",
            padding: "24px 20px",
            border: "1px solid #fecaca",
            borderRadius: 8,
            backgroundColor: "#fef2f2"
          }}
        >
          <h4 style={{ color: "#991b1b", fontWeight: "bold", marginBottom: 12 }}>
            เฉพาะผู้ดูแลระบบงานยานพาหนะ
          </h4>
          <p style={{ color: "#7f1d1d", fontSize: "0.95rem", marginBottom: 16 }}>
            หน้านี้สงวนไว้สำหรับเจ้าหน้าที่งานยานพาหนะ (กลุ่มงานบริหารทั่วไป) และงานสารสนเทศ (IT) เท่านั้น
          </p>
          <a href={fallbackUrl} style={{ textDecoration: "none" }}>
            <button
              className="btn btn-primary"
              type="button"
              style={{ backgroundColor: "#2563eb", borderColor: "#2563eb", borderRadius: 6 }}
            >
              กลับไปหน้าแบบจองรถ
            </button>
          </a>
        </div>
      </div>
    );
  }

  return children;
};
